"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IRtcEngineImpl = exports.RTCENGINE_KEY = void 0;
const NATIVE_RTC = __importStar(require("@iris/native-rtc"));
const BaseType_1 = require("../base/BaseType");
const DefaultValue_1 = require("../base/DefaultValue");
const IrisClient_1 = require("../engine/IrisClient");
const IrisClientManager_1 = require("../engine/IrisClientManager");
const IrisClientObserver_1 = require("../engine/IrisClientObserver");
const AgoraConsole_1 = require("../util/AgoraConsole");
const AgoraTranslate_1 = require("../util/AgoraTranslate");
const AgoraTool_1 = require("../util/AgoraTool");
exports.RTCENGINE_KEY = 'RtcEngine';
//@ts-ignore
class IRtcEngineImpl {
    constructor(engine) {
        this._engine = engine;
    }
    release() {
        let processFunc = () => __awaiter(this, void 0, void 0, function* () {
            // P2.4 (GEN-audit): cleanup virtual background processor WASM prima del
            // release engine. senza questo il processor resta allocato con handle
            // WASM non liberato → leak cumulativo su multi rejoin lezione.
            const gs = this._engine.globalState;
            if (gs.virtualBackgroundProcessor) {
                try {
                    yield gs.virtualBackgroundProcessor.disable();
                    // `release` non è sempre presente in tutte le versioni extension —
                    // optional call via any.
                    const p = gs.virtualBackgroundProcessor;
                    if (typeof p.release === 'function') {
                        yield p.release();
                    }
                }
                catch (e) {
                    AgoraConsole_1.AgoraConsole.warn(`[VirtualBg] release error: ${e}`);
                }
                gs.virtualBackgroundProcessor = undefined;
                gs.virtualBackgroundEnabled = false;
                gs.virtualBackgroundSource = undefined;
                gs.virtualBackgroundPipedTrack = undefined;
            }
            yield this._engine.irisClientManager.release();
            return this._engine.returnResult();
        });
        return this._engine.execute(processFunc);
    }
    setAppType(appType) {
        let processFunc = () => __awaiter(this, void 0, void 0, function* () {
            this._engine.globalState.AgoraRTC.setAppType(appType);
            return this._engine.returnResult();
        });
        return this._engine.execute(processFunc);
    }
    initialize_0320339(context) {
        let processFunc = () => __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c;
            // Return OK if already initialized.
            if (this._engine.irisClientManager.irisClientList.length > 0) {
                return this._engine.returnResult(true, NATIVE_RTC.ERROR_CODE_TYPE.ERR_OK);
            }
            new IrisClient_1.IrisClient(this._engine);
            this._engine.globalState.rtcEngineContext = context;
            if (context.areaCode) {
                this._engine.globalState.AgoraRTC.setArea([
                    AgoraTranslate_1.AgoraTranslate.NATIVE_RTCAREA_CODE2AREAS(context.areaCode),
                ]);
            }
            if (typeof ((_a = context === null || context === void 0 ? void 0 : context.logConfig) === null || _a === void 0 ? void 0 : _a.level) === 'number' &&
                ((_b = context === null || context === void 0 ? void 0 : context.logConfig) === null || _b === void 0 ? void 0 : _b.level) >= 0) {
                this._engine.globalState.AgoraRTC.setLogLevel(AgoraTranslate_1.AgoraTranslate.NATIVE_RTCLOG_LEVEL2Number((_c = context === null || context === void 0 ? void 0 : context.logConfig) === null || _c === void 0 ? void 0 : _c.level));
            }
            let result = this._engine.globalState.AgoraRTC.checkSystemRequirements();
            return this._engine.returnResult(result);
        });
        return this._engine.execute(processFunc);
    }
    joinChannel_f097389(token, channelId, info, uid) {
        let irisClient = this._engine.irisClientManager.getIrisClient();
        return this.joinChannel_cdbb747(token, channelId, uid, irisClient.irisClientState);
    }
    joinChannel_cdbb747(token, channelId, uid, options) {
        let processJoinChannel = () => __awaiter(this, void 0, void 0, function* () {
            yield this._engine.implHelper.joinChannel(token, channelId, uid, options);
            return this._engine.returnResult();
        });
        return this._engine.execute(processJoinChannel);
    }
    updateChannelMediaOptions_7bfc1d7(options) {
        let processFunc = () => __awaiter(this, void 0, void 0, function* () {
            yield this._engine.implHelper.updateChannelMediaOptions(options);
            return this._engine.returnResult();
        });
        return this._engine.execute(processFunc);
    }
    leaveChannel() {
        return this.leaveChannel_2c0e3aa(DefaultValue_1.defaultLeaveChannelOptions);
    }
    leaveChannel_2c0e3aa(options) {
        let processFunc = () => __awaiter(this, void 0, void 0, function* () {
            var _a;
            if (this._engine.irisClientManager.irisClientList.length === 0) {
                return this._engine.returnResult();
            }
            yield this._engine.irisClientManager.irisClientObserver.notifyLocal(IrisClientObserver_1.NotifyType.UNPUBLISH_TRACK, [
                ...this._engine.irisClientManager.localAudioTrackPackages,
                ...this._engine.irisClientManager.localVideoTrackPackages,
            ]);
            for (let irisClient of this._engine.irisClientManager.irisClientList) {
                let agoraRTCClient = irisClient.agoraRTCClient;
                if (agoraRTCClient) {
                    //读取 options
                    for (let trackPackage of irisClient.audioTrackPackages) {
                        if (trackPackage.track) {
                            let track = trackPackage.track;
                            if (options.stopMicrophoneRecording) {
                                yield this._engine.trackHelper.setMuted(track, true);
                            }
                        }
                    }
                    if (options.stopAllEffect) {
                        this.stopAllEffects();
                        //todo effect
                    }
                    if (options.stopAudioMixing) {
                        //todo audio Mixing
                    }
                    //为了防止离开频道后丢失了channelName和uid，所以需要先保存一下
                    let con = {
                        channelId: agoraRTCClient.channelName,
                        localUid: agoraRTCClient.uid,
                    };
                    agoraRTCClient.remoteUsers.map((remoteUser) => {
                        var _a;
                        this._engine.rtcEngineEventHandler.onUserOffline_0a32aac((_a = irisClient.connection) !== null && _a !== void 0 ? _a : con, remoteUser.uid, NATIVE_RTC.USER_OFFLINE_REASON_TYPE.USER_OFFLINE_DROPPED);
                    });
                    try {
                        // webSDK在leave的时候会直接reset client 没有release方法
                        yield this._engine.clientHelper.leave(agoraRTCClient);
                        AgoraConsole_1.AgoraConsole.log(`leaveChannel success`);
                    }
                    catch (e) {
                        AgoraConsole_1.AgoraConsole.error(`leaveChannel failed:${e}`);
                        this._engine.rtcEngineEventHandler.onError_d26c0fd(NATIVE_RTC.ERROR_CODE_TYPE.ERR_LEAVE_CHANNEL_REJECTED, '');
                    }
                    this._engine.rtcEngineEventHandler.onLeaveChannel_c8e730d((_a = irisClient.connection) !== null && _a !== void 0 ? _a : con, new NATIVE_RTC.RtcStats());
                    // AUDIT-v18: await release per evitare race con leaveChannel ritorno:
                    // senza await, chiamate successive (enterChannel rejoin) possono
                    // trovare irisClientList in stato inconsistente.
                    yield irisClient.release();
                }
            }
            return this._engine.returnResult();
        });
        return this._engine.execute(processFunc);
    }
    setChannelProfile_a78fa4f(profile) {
        let processFunc = () => __awaiter(this, void 0, void 0, function* () {
            // Return OK if already initialized.
            if (profile == null || profile == undefined) {
                return this._engine.returnResult(false, -NATIVE_RTC.ERROR_CODE_TYPE.ERR_INVALID_ARGUMENT);
            }
            this._engine.globalState.channelProfile = profile;
            return this._engine.returnResult();
        });
        return this._engine.execute(processFunc);
    }
    //可以在加入频道前后调用
    setClientRole_3426fa6(role) {
        let options = {
            audienceLatencyLevel: NATIVE_RTC.AUDIENCE_LATENCY_LEVEL_TYPE
                .AUDIENCE_LATENCY_LEVEL_ULTRA_LOW_LATENCY,
        };
        return this.setClientRole_b46cc48(role, options);
    }
    setClientRole_b46cc48(role, options) {
        let processFunc = () => __awaiter(this, void 0, void 0, function* () {
            let irisClient = this._engine.irisClientManager.getIrisClient();
            let oldRole = irisClient.irisClientState.clientRoleType;
            irisClient.irisClientState.clientRoleType = role;
            let client = irisClient === null || irisClient === void 0 ? void 0 : irisClient.agoraRTCClient;
            client &&
                (yield this._engine.clientHelper.setClientRole(client, role, options.audienceLatencyLevel));
            if (role === NATIVE_RTC.CLIENT_ROLE_TYPE.CLIENT_ROLE_AUDIENCE) {
                this.muteLocalAudioStream_5039d15(true);
                this.muteLocalVideoStream_5039d15(true);
            }
            //如果已经加入频道
            if (client === null || client === void 0 ? void 0 : client.channelName) {
                this._engine.rtcEngineEventHandler.onClientRoleChanged_2acaf10(irisClient.connection, oldRole, role, options);
            }
            return this._engine.returnResult();
        });
        return this._engine.execute(processFunc);
    }
    enableVideo() {
        let processVideoTrack = () => __awaiter(this, void 0, void 0, function* () {
            this._engine.globalState.enabledVideo = true;
            this.enableLocalVideo_5039d15(true);
            this.muteLocalVideoStream_5039d15(false);
            this.muteAllRemoteVideoStreams_5039d15(false);
            this.muteAllRemoteVideoStreams_5039d15(false);
            return this._engine.returnResult();
        });
        return this._engine.execute(processVideoTrack);
    }
    disableVideo() {
        let processVideoTrack = () => __awaiter(this, void 0, void 0, function* () {
            this._engine.globalState.enabledVideo = false;
            this.enableLocalVideo_5039d15(false);
            this.muteLocalVideoStream_5039d15(true);
            this.muteAllRemoteVideoStreams_5039d15(true);
            this.muteAllRemoteVideoStreams_5039d15(true);
            return this._engine.returnResult();
        });
        return this._engine.execute(processVideoTrack);
    }
    startPreview() {
        return this.startPreview_4fd718e(NATIVE_RTC.VIDEO_SOURCE_TYPE.VIDEO_SOURCE_CAMERA);
    }
    startPreview_4fd718e(sourceType) {
        let process = () => __awaiter(this, void 0, void 0, function* () {
            if (this._engine.globalState.enabledVideo == false) {
                AgoraConsole_1.AgoraConsole.warn('call enableVideo(true) before startPreview');
                return this._engine.returnResult();
            }
            if (sourceType >= 5) {
                AgoraConsole_1.AgoraConsole.error('Invalid source type');
                return this._engine.returnResult(false);
            }
            AgoraConsole_1.AgoraConsole.debug(`startPreview_69ae92f1 videoSource: ${sourceType}`);
            if (sourceType == null) {
                sourceType == NATIVE_RTC.VIDEO_SOURCE_TYPE.VIDEO_SOURCE_CAMERA_PRIMARY;
            }
            let videoTrackPackage;
            videoTrackPackage = this._engine.irisClientManager.getLocalVideoTrackPackageBySourceType(sourceType)[0];
            if (!videoTrackPackage) {
                videoTrackPackage = new IrisClientManager_1.VideoTrackPackage(undefined, undefined, sourceType, undefined);
                this._engine.irisClientManager.addLocalVideoTrackPackage(videoTrackPackage);
                if (this._engine.implHelper.isVideoCamera(sourceType)) {
                    let cTrack;
                    cTrack = yield this._engine.implHelper.createVideoCameraTrack();
                    videoTrackPackage.track = cTrack;
                    // GEN-153: se l'utente ha già impostato un virtual background prima
                    // che la camera fosse avviata (pre-activation flow), applicalo ora
                    // che il track esiste. Config è cached in globalState.
                    if (this._engine.globalState.virtualBackgroundExtension) {
                        try {
                            yield this._applyVirtualBackgroundToCameraTrack(cTrack);
                        }
                        catch (e) {
                            AgoraConsole_1.AgoraConsole.warn(`[VirtualBg] apply post-createTrack failed: ${e}`);
                        }
                    }
                }
            }
            videoTrackPackage.isPreview = true;
            try {
                let track = videoTrackPackage === null || videoTrackPackage === void 0 ? void 0 : videoTrackPackage.track;
                if (track) {
                    yield this._engine.trackHelper.setEnabled(track, true);
                    if (videoTrackPackage.element) {
                        this._engine.trackHelper.play(track, videoTrackPackage.element, videoTrackPackage.videoPlayerConfig);
                    }
                }
            }
            catch (err) {
                AgoraConsole_1.AgoraConsole.error(err);
                return this._engine.returnResult(false);
            }
            this._engine.rtcEngineEventHandler.onLocalVideoStateChanged_a44228a(sourceType, NATIVE_RTC.LOCAL_VIDEO_STREAM_STATE.LOCAL_VIDEO_STREAM_STATE_ENCODING, 0);
            return this._engine.returnResult();
        });
        return this._engine.execute(process);
    }
    stopPreview() {
        return this.stopPreview_4fd718e(NATIVE_RTC.VIDEO_SOURCE_TYPE.VIDEO_SOURCE_CAMERA);
    }
    stopPreview_4fd718e(sourceType) {
        let process = () => __awaiter(this, void 0, void 0, function* () {
            if (sourceType >= 5) {
                AgoraConsole_1.AgoraConsole.error('Invalid source type');
                return this._engine.returnResult(false);
            }
            AgoraConsole_1.AgoraConsole.debug(`stopPreview_11d53f7b videoSource: ${sourceType}`);
            if (sourceType == null) {
                sourceType == NATIVE_RTC.VIDEO_SOURCE_TYPE.VIDEO_SOURCE_CAMERA_PRIMARY;
            }
            let videoTrackPackage;
            videoTrackPackage = this._engine.irisClientManager.getLocalVideoTrackPackageBySourceType(sourceType)[0];
            if (videoTrackPackage) {
                videoTrackPackage.isPreview = false;
                try {
                    let track = videoTrackPackage.track;
                    if (track) {
                        yield this._engine.trackHelper.setEnabled(track, false);
                        if (videoTrackPackage.element && videoTrackPackage.track) {
                            this._engine.trackHelper.stop(videoTrackPackage.track);
                        }
                    }
                }
                catch (err) {
                    AgoraConsole_1.AgoraConsole.error(err);
                    return this._engine.returnResult(false);
                }
                this._engine.rtcEngineEventHandler.onLocalVideoStateChanged_a44228a(sourceType, NATIVE_RTC.LOCAL_VIDEO_STREAM_STATE.LOCAL_VIDEO_STREAM_STATE_STOPPED, 0);
            }
            return this._engine.returnResult();
        });
        return this._engine.execute(process);
    }
    setVideoEncoderConfiguration_89677d8(config) {
        let processFunc = () => __awaiter(this, void 0, void 0, function* () {
            this._engine.globalState.videoEncoderConfiguration = config;
            for (let videoTrackPackage of this._engine.irisClientManager
                .localVideoTrackPackages) {
                if (videoTrackPackage.track) {
                    let track = videoTrackPackage.track;
                    yield track.setEncoderConfiguration(AgoraTranslate_1.AgoraTranslate.NATIVE_RTCVideoEncoderConfiguration2VideoEncoderConfiguration(config));
                }
            }
            return this._engine.returnResult();
        });
        return this._engine.execute(processFunc);
    }
    setupLocalVideo_acc9c38(canvas) {
        let processVideoTrack = () => __awaiter(this, void 0, void 0, function* () {
            let sourceType = canvas.sourceType ||
                NATIVE_RTC.VIDEO_SOURCE_TYPE.VIDEO_SOURCE_CAMERA_PRIMARY;
            let trackPackage = this._engine.irisClientManager.getLocalVideoTrackPackageBySourceType(sourceType)[0];
            if (!trackPackage) {
                let config = {
                    fit: AgoraTranslate_1.AgoraTranslate.NATIVE_RTC_RENDER_MODE_TYPE2Fit(canvas.renderMode
                        ? canvas.renderMode
                        : NATIVE_RTC.RENDER_MODE_TYPE.RENDER_MODE_FIT),
                    mirror: canvas.mirrorMode ===
                        NATIVE_RTC.VIDEO_MIRROR_MODE_TYPE.VIDEO_MIRROR_MODE_AUTO ||
                        canvas.mirrorMode ===
                            NATIVE_RTC.VIDEO_MIRROR_MODE_TYPE.VIDEO_MIRROR_MODE_ENABLED,
                };
                trackPackage = new IrisClientManager_1.VideoTrackPackage(canvas.view, config, sourceType);
                this._engine.irisClientManager.addLocalVideoTrackPackage(trackPackage);
                if (this._engine.implHelper.isVideoCamera(sourceType)) {
                    let cTrack;
                    cTrack = yield this._engine.implHelper.createVideoCameraTrack();
                    trackPackage.track = cTrack;
                }
            }
            trackPackage.type = sourceType;
            trackPackage.element = canvas.view;
            let track = trackPackage.track;
            if (track) {
                yield this._engine.trackHelper.setEnabled(track, true);
                // Fix: the original code gated play on trackPackage.isPreview, but
                // isPreview is only flipped by startPreview() (camera path). For screen
                // tracks (created via startScreenCapture) isPreview stays false, so
                // setupLocalVideo with sourceType=SCREEN_PRIMARY never plays the track
                // locally — the sharer sees a blank view even though the track is
                // published. Calling setupLocalVideo with an element already expresses
                // the intent to preview; play unconditionally.
                if (trackPackage.element) {
                    this._engine.trackHelper.play(track, trackPackage.element, trackPackage.videoPlayerConfig);
                }
            }
            return this._engine.returnResult();
        });
        return this._engine.execute(processVideoTrack);
    }
    enableAudio() {
        let processAudioTracks = () => __awaiter(this, void 0, void 0, function* () {
            this._engine.globalState.enabledAudio = true;
            this.enableLocalAudio_5039d15(true);
            this.muteLocalAudioStream_5039d15(false);
            this.muteAllRemoteAudioStreams_5039d15(false);
            return this._engine.returnResult();
        });
        return this._engine.execute(processAudioTracks);
    }
    disableAudio() {
        let processAudioTracks = () => __awaiter(this, void 0, void 0, function* () {
            this._engine.globalState.enabledAudio = false;
            this.enableLocalAudio_5039d15(false);
            this.muteLocalAudioStream_5039d15(true);
            this.muteAllRemoteAudioStreams_5039d15(true);
            return this._engine.returnResult();
        });
        return this._engine.execute(processAudioTracks);
    }
    setAudioProfile_d944543(profile, scenario) {
        let processFunc = () => __awaiter(this, void 0, void 0, function* () {
            this._engine.globalState.audioProfile = profile;
            this._engine.globalState.rtcEngineContext.audioScenario = scenario;
            return this._engine.returnResult();
        });
        return this._engine.execute(processFunc);
    }
    setAudioProfile_ac39c15(profile) {
        let processFunc = () => __awaiter(this, void 0, void 0, function* () {
            this._engine.globalState.audioProfile = profile;
            return this._engine.returnResult();
        });
        return this._engine.execute(processFunc);
    }
    enableLocalAudio_5039d15(enabled) {
        let processFunc = () => __awaiter(this, void 0, void 0, function* () {
            this._engine.globalState.enabledLocalAudio = enabled;
            if (enabled) {
                if (!this._engine.irisClientManager.getLocalAudioTrackPackageBySourceType(BaseType_1.IrisAudioSourceType.kAudioSourceTypeMicrophonePrimary)[0]) {
                    let audioTrack = yield this._engine.implHelper.createMicrophoneAudioTrack();
                    this._engine.irisClientManager.addLocalAudioTrackPackage(new IrisClientManager_1.AudioTrackPackage(BaseType_1.IrisAudioSourceType.kAudioSourceTypeMicrophonePrimary, audioTrack));
                }
                try {
                }
                catch (e) {
                    AgoraConsole_1.AgoraConsole.warn(`createAudioTrack error: ${e}`);
                }
            }
            // Fix indicatore browser microfono: enableLocalAudio(false) deve spegnere
            // l'hardware audio (→ indicator off) SENZA toccare lo stato di publish.
            // Filtro solo i mic track primary: evita side-effect su eventuali custom
            // audio tracks e sullo stream audio di screen-share capture.
            const micPackages = this._engine.irisClientManager.localAudioTrackPackages
                .filter((p) => p.type === BaseType_1.IrisAudioSourceType.kAudioSourceTypeMicrophonePrimary);
            for (let trackPackage of micPackages) {
                yield this._engine.trackHelper.setEnabled(trackPackage.track, enabled);
            }
            // NON chiamiamo UNPUBLISH_TRACK/MUTE_TRACK: il publish state è controllato
            // separatamente da updateChannelMediaOptions(publishMicrophoneTrack).
            // Questo disaccoppia "release hardware" (enableLocal*) da "publish track"
            // (updateChannelMediaOptions), permettendo di spegnere l'indicator browser
            // senza far cascading unpublish sugli altri client (es. secondary screen).
            this._engine.rtcEngineEventHandler.onLocalAudioStateChanged_13b6c02({
                localUid: undefined,
                channelId: undefined,
            }, enabled
                ? NATIVE_RTC.LOCAL_AUDIO_STREAM_STATE
                    .LOCAL_AUDIO_STREAM_STATE_RECORDING
                : NATIVE_RTC.LOCAL_AUDIO_STREAM_STATE
                    .LOCAL_AUDIO_STREAM_STATE_STOPPED, NATIVE_RTC.LOCAL_AUDIO_STREAM_REASON.LOCAL_AUDIO_STREAM_REASON_OK);
            this._engine.rtcEngineEventHandler.onLocalAudioStateChanged_f33d789(enabled
                ? NATIVE_RTC.LOCAL_AUDIO_STREAM_STATE
                    .LOCAL_AUDIO_STREAM_STATE_RECORDING
                : NATIVE_RTC.LOCAL_AUDIO_STREAM_STATE
                    .LOCAL_AUDIO_STREAM_STATE_STOPPED, NATIVE_RTC.LOCAL_AUDIO_STREAM_REASON.LOCAL_AUDIO_STREAM_REASON_OK);
            return this._engine.returnResult();
        });
        return this._engine.execute(processFunc);
    }
    enableLocalVideo_5039d15(enabled) {
        let processFunc = () => __awaiter(this, void 0, void 0, function* () {
            this._engine.globalState.enabledLocalVideo = enabled;
            // Fix indicatore browser camera: enableLocalVideo(false) deve spegnere
            // l'hardware camera (→ indicator off) SENZA rompere pipeline screen
            // share. Il comportamento originale chiamava setEnabled(false) anche
            // sui screen capture track e generava UNPUBLISH_TRACK su tutti,
            // distruggendo la sessione screen share del docente sharer e
            // potenzialmente chiudendo il track globale.
            const cameraPackages = this._engine.irisClientManager.localVideoTrackPackages
                .filter((p) => this._engine.implHelper.isVideoCamera(p.type));
            for (let trackPackage of cameraPackages) {
                yield this._engine.trackHelper.setEnabled(trackPackage.track, enabled);
            }
            // NON chiamiamo UNPUBLISH_TRACK/MUTE_TRACK: il publish è gestito
            // separatamente da updateChannelMediaOptions(publishCameraTrack).
            return this._engine.returnResult();
        });
        return this._engine.execute(processFunc);
    }
    muteLocalAudioStream_5039d15(mute) {
        let processFunc = () => __awaiter(this, void 0, void 0, function* () {
            yield this._engine.irisClientManager.irisClientObserver.notifyLocal(mute ? IrisClientObserver_1.NotifyType.UNPUBLISH_TRACK : IrisClientObserver_1.NotifyType.PUBLISH_TRACK, this._engine.irisClientManager.localAudioTrackPackages);
            return this._engine.returnResult();
        });
        return this._engine.execute(processFunc);
    }
    muteLocalVideoStream_5039d15(mute) {
        let process = () => __awaiter(this, void 0, void 0, function* () {
            yield this._engine.irisClientManager.irisClientObserver.notifyLocal(mute ? IrisClientObserver_1.NotifyType.UNPUBLISH_TRACK : IrisClientObserver_1.NotifyType.PUBLISH_TRACK, this._engine.irisClientManager.localVideoTrackPackages);
            return this._engine.returnResult();
        });
        return this._engine.execute(process);
    }
    createDataStream_5862815(config) {
        let process = () => __awaiter(this, void 0, void 0, function* () {
            for (let irisClient of this._engine.irisClientManager.irisClientList) {
                irisClient.irisClientState.dataStreamConfig = config;
            }
            return this._engine.returnResult(true, 0, JSON.stringify({
                result: 0,
                streamId: 0,
            }));
        });
        return this._engine.execute(process);
    }
    sendStreamMessage_8715a45(streamId, data, length) {
        let process = () => __awaiter(this, void 0, void 0, function* () {
            let irisClient = this._engine.irisClientManager.getIrisClient();
            let agoraRTCClient = irisClient === null || irisClient === void 0 ? void 0 : irisClient.agoraRTCClient;
            if (!(agoraRTCClient === null || agoraRTCClient === void 0 ? void 0 : agoraRTCClient.channelName)) {
                return this._engine.irisRtcErrorHandler.notInChannel();
            }
            else {
                yield this._engine.clientHelper.sendStreamMessage(agoraRTCClient, {
                    payload: data,
                    syncWithAudio: irisClient.irisClientState.dataStreamConfig.syncWithAudio,
                });
            }
            return this._engine.returnResult();
        });
        return this._engine.execute(process);
    }
    muteAllRemoteVideoStreams_5039d15(mute) {
        let processFunc = () => __awaiter(this, void 0, void 0, function* () {
            yield this._engine.irisClientManager.irisClientObserver.notifyRemote(mute
                ? IrisClientObserver_1.NotifyRemoteType.UNSUBSCRIBE_VIDEO_TRACK
                : IrisClientObserver_1.NotifyRemoteType.SUBSCRIBE_VIDEO_TRACK, this._engine.irisClientManager.remoteUserPackages);
            return this._engine.returnResult();
        });
        return this._engine.execute(processFunc);
    }
    muteRemoteVideoStream_dbdc15a(uid, mute) {
        let processFunc = () => __awaiter(this, void 0, void 0, function* () {
            let remoteUserPackage = this._engine.irisClientManager.getRemoteUserPackageByUid(uid);
            yield this._engine.irisClientManager.irisClientObserver.notifyRemote(mute
                ? IrisClientObserver_1.NotifyRemoteType.UNSUBSCRIBE_VIDEO_TRACK
                : IrisClientObserver_1.NotifyRemoteType.SUBSCRIBE_VIDEO_TRACK, [remoteUserPackage]);
            return this._engine.returnResult();
        });
        return this._engine.execute(processFunc);
    }
    muteAllRemoteAudioStreams_5039d15(mute) {
        let processFunc = () => __awaiter(this, void 0, void 0, function* () {
            yield this._engine.irisClientManager.irisClientObserver.notifyRemote(mute
                ? IrisClientObserver_1.NotifyRemoteType.UNSUBSCRIBE_AUDIO_TRACK
                : IrisClientObserver_1.NotifyRemoteType.SUBSCRIBE_AUDIO_TRACK, this._engine.irisClientManager.remoteUserPackages);
            return this._engine.returnResult();
        });
        return this._engine.execute(processFunc);
    }
    muteRemoteAudioStream_dbdc15a(uid, mute) {
        let processFunc = () => __awaiter(this, void 0, void 0, function* () {
            let remoteUserPackage = this._engine.irisClientManager.getRemoteUserPackageByUid(uid);
            yield this._engine.irisClientManager.irisClientObserver.notifyRemote(mute
                ? IrisClientObserver_1.NotifyRemoteType.UNSUBSCRIBE_AUDIO_TRACK
                : IrisClientObserver_1.NotifyRemoteType.SUBSCRIBE_AUDIO_TRACK, [remoteUserPackage]);
            return this._engine.returnResult();
        });
        return this._engine.execute(processFunc);
    }
    enableAudioVolumeIndication_39794a0(interval, smooth, reportVad) {
        let processFunc = () => __awaiter(this, void 0, void 0, function* () {
            var _a;
            this._engine.globalState.enableAudioVolumeIndicationConfig = Object.assign(Object.assign(Object.assign(Object.assign({}, this._engine.globalState.enableAudioVolumeIndicationConfig), (interval && { interval })), (smooth && { smooth })), (reportVad && { reportVad }));
            let agoraRTCClient = (_a = this._engine.irisClientManager.getIrisClient()) === null || _a === void 0 ? void 0 : _a.agoraRTCClient;
            this._engine.globalState.enableAudioVolumeIndication = interval > 0;
            if (this._engine.globalState.enableAudioVolumeIndication) {
                this.setParameters_3a2037f(JSON.stringify({ AUDIO_VOLUME_INDICATION_INTERVAL: interval }));
                agoraRTCClient === null || agoraRTCClient === void 0 ? void 0 : agoraRTCClient.enableAudioVolumeIndicator();
            }
            return this._engine.returnResult();
        });
        return this._engine.execute(processFunc);
    }
    playEffect_531a783(soundId, filePath, loopCount, pitch, //web没有
    pan, //web没有
    gain, publish, startPos) {
        let processFunc = () => __awaiter(this, void 0, void 0, function* () {
            if (!this._engine.globalState.enabledAudio ||
                !this._engine.globalState.enabledLocalAudio) {
                AgoraConsole_1.AgoraConsole.error('please enableAudio first');
                return this._engine.returnResult(false);
            }
            let irisClient = this._engine.irisClientManager.getIrisClient();
            let bufferSourceAudioTrackPackage;
            let bufferSourceAudioTrackInitConfig = {
                source: '',
            };
            //如果是带有http或者https的则不拼接,否则拼接origin
            if (filePath.startsWith('https://') || filePath.startsWith('http://')) {
                bufferSourceAudioTrackInitConfig.source = filePath;
            }
            else {
                bufferSourceAudioTrackInitConfig.source = `${location.origin}/${filePath}`;
            }
            try {
                bufferSourceAudioTrackPackage = yield this._engine.implHelper.createBufferSourceAudioTrack(soundId, bufferSourceAudioTrackInitConfig);
                AgoraConsole_1.AgoraConsole.log('createBufferSourceAudioTrack success');
            }
            catch (err) {
                err && AgoraConsole_1.AgoraConsole.error(err);
                return this._engine.returnResult(false);
            }
            if (bufferSourceAudioTrackPackage.track) {
                //设置音效
                if (gain) {
                    bufferSourceAudioTrackPackage.track.setVolume(gain);
                }
                try {
                    //https://docportal.shengwang.cn/cn/video-call-4.x/audio_effect_mixing_web_ng?platform=Web#发布多个音频轨道以实现混音
                    let config = {
                        loop: false,
                    };
                    if (typeof loopCount === 'number' && loopCount >= 0) {
                        config.cycle = loopCount;
                        if (loopCount === -1) {
                            config.loop = true;
                        }
                    }
                    //native是毫秒 web是秒
                    if (startPos) {
                        config.startPlayTime = Math.floor(startPos / 1000);
                    }
                    bufferSourceAudioTrackPackage.track.startProcessAudioBuffer(config);
                    this._engine.trackHelper.play(bufferSourceAudioTrackPackage.track);
                }
                catch (reason) {
                    AgoraConsole_1.AgoraConsole.error(reason);
                }
            }
            if (publish) {
                yield this._engine.irisClientManager.irisClientObserver.notifyLocal(IrisClientObserver_1.NotifyType.PUBLISH_TRACK, [bufferSourceAudioTrackPackage], [irisClient]);
            }
            return this._engine.returnResult();
        });
        return this._engine.execute(processFunc);
    }
    stopEffect_46f8ab7(soundId) {
        let processFunc = () => __awaiter(this, void 0, void 0, function* () {
            let bufferSourceAudioTrackPackage = this._engine.irisClientManager.getLocalAudioTrackPackageBySourceType(BaseType_1.IrisAudioSourceType.kAudioSourceTypeBufferSourceAudio)[0];
            if (!(bufferSourceAudioTrackPackage === null || bufferSourceAudioTrackPackage === void 0 ? void 0 : bufferSourceAudioTrackPackage.track)) {
                AgoraConsole_1.AgoraConsole.error(`soundId:${soundId} not found`);
                this._engine.rtcEngineEventHandler.onError_d26c0fd(NATIVE_RTC.ERROR_CODE_TYPE.ERR_FAILED, `soundId:${soundId} not found`);
                return this._engine.returnResult();
            }
            yield this._engine.irisClientManager.irisClientObserver.notifyLocal(IrisClientObserver_1.NotifyType.REMOVE_TRACK, [bufferSourceAudioTrackPackage]);
            return this._engine.returnResult();
        });
        return this._engine.execute(processFunc);
    }
    stopAllEffects() {
        let processFunc = () => __awaiter(this, void 0, void 0, function* () {
            let bufferSourceAudioTrackPackages = this._engine.irisClientManager.getLocalAudioTrackPackageBySourceType(BaseType_1.IrisAudioSourceType.kAudioSourceTypeBufferSourceAudio);
            bufferSourceAudioTrackPackages.map((bufferSourceAudioTrackPackage) => {
                if (bufferSourceAudioTrackPackage.track &&
                    bufferSourceAudioTrackPackage.soundId) {
                    this.stopEffect_46f8ab7(bufferSourceAudioTrackPackage.soundId);
                }
            });
            return this._engine.returnResult();
        });
        return this._engine.execute(processFunc);
    }
    setLogLevel_f125d83(level) {
        let processFunc = () => __awaiter(this, void 0, void 0, function* () {
            AgoraConsole_1.AgoraConsole.logLevel = level;
            let numberLevel = AgoraTranslate_1.AgoraTranslate.NATIVE_RTCLOG_LEVEL2Number(level);
            this._engine.globalState.AgoraRTC.setLogLevel(numberLevel);
            return this._engine.returnResult();
        });
        return this._engine.execute(processFunc);
    }
    startScreenCapture_270da41(captureParams) {
        let process = () => __awaiter(this, void 0, void 0, function* () {
            if (this._engine.irisClientManager.getScreenCaptureStatus()) {
                AgoraConsole_1.AgoraConsole.error('you have already startScreenCapture');
                return this._engine.returnResult(false);
            }
            if (!captureParams.captureVideo) {
                AgoraConsole_1.AgoraConsole.log('captureVideo is false, do nothing');
                return this._engine.returnResult();
            }
            let videoType = NATIVE_RTC.VIDEO_SOURCE_TYPE.VIDEO_SOURCE_SCREEN_PRIMARY;
            try {
                yield this._engine.implHelper.createScreenTrack(captureParams, videoType);
                AgoraConsole_1.AgoraConsole.log('ScreenShare track create success');
            }
            catch (err) {
                err && AgoraConsole_1.AgoraConsole.error(err);
                return this._engine.returnResult(false);
            }
            return this._engine.returnResult();
        });
        return this._engine.execute(process);
    }
    stopScreenCapture() {
        return this.stopScreenCapture_4fd718e(NATIVE_RTC.VIDEO_SOURCE_TYPE.VIDEO_SOURCE_SCREEN_PRIMARY);
    }
    stopScreenCapture_4fd718e(sourceType) {
        //需要处理
        let processFunc = () => __awaiter(this, void 0, void 0, function* () {
            let irisClientManager = this._engine.irisClientManager;
            if (!this._engine.irisClientManager.getScreenCaptureStatus()) {
                AgoraConsole_1.AgoraConsole.warn('screenCapture is not start');
                return this._engine.returnResult();
            }
            let videoPackages = irisClientManager.getLocalVideoTrackPackageBySourceType(sourceType);
            let audioPackages = irisClientManager.getLocalAudioTrackPackageBySourceType(BaseType_1.IrisAudioSourceType.kAudioSourceTypeScreenCapture);
            if (videoPackages.length == 0) {
                AgoraConsole_1.AgoraConsole.error(`sourceType:${sourceType} is not start`);
                return this._engine.returnResult(false);
            }
            yield this._engine.irisClientManager.irisClientObserver.notifyLocal(IrisClientObserver_1.NotifyType.REMOVE_TRACK, [...videoPackages, ...audioPackages]);
            return this._engine.returnResult();
        });
        return this._engine.execute(processFunc);
    }
    registerEventHandler_5fc0465(eventHandler) {
        let processFunc = () => __awaiter(this, void 0, void 0, function* () {
            this._engine.irisEventHandlerManager.addEventHandler(exports.RTCENGINE_KEY, eventHandler);
            return this._engine.returnResult();
        });
        return this._engine.execute(processFunc);
    }
    unregisterEventHandler_5fc0465(eventHandler) {
        let processFunc = () => __awaiter(this, void 0, void 0, function* () {
            this._engine.irisEventHandlerManager.removeEventHandler(exports.RTCENGINE_KEY, eventHandler);
            return this._engine.returnResult();
        });
        return this._engine.execute(processFunc);
    }
    setParameters_3a2037f(parameters) {
        //example:
        //[dart]await rtcEngine.setParameters('{"AUDIO_VOLUME_INDICATION_INTERVAL": 10000}');
        //parameters please use json string
        let fun = () => __awaiter(this, void 0, void 0, function* () {
            try {
                let json = JSON.parse(parameters);
                let keyList = Object.keys(json);
                for (let i = 0; i < keyList.length; i++) {
                    switch (keyList[i]) {
                        case 'enableLogUpload':
                            if (json[keyList[i]] === true) {
                                this._engine.globalState.AgoraRTC.enableLogUpload();
                            }
                            else {
                                this._engine.globalState.AgoraRTC.disableLogUpload();
                            }
                            break;
                        default:
                            this._engine.globalState.AgoraRTC.setParameter(keyList[i], json[keyList[i]]);
                    }
                }
            }
            catch (e) {
                AgoraConsole_1.AgoraConsole.log(e);
                return this._engine.returnResult(false);
            }
            return this._engine.returnResult();
        });
        return this._engine.execute(fun);
    }
    // Impl per v0.9.2 (originariamente stub "not supported").
    // AgoraRTC Web SDK 4.x non richiede un register esplicito: l'account viene
    // creato automaticamente al joinChannelWithUserAccount. Pre-popoliamo però
    // la UserInfo cache in modo che getUserInfoByUserAccount funzioni prima del join.
    registerLocalUserAccount_ccad422(appId, userAccount) {
        // Nessuna API Web SDK da chiamare. Il JoinChannel successivo gestirà
        // la registrazione lato server. Rispondiamo success per coerenza col Native.
        return this._engine.returnResult();
    }
    joinChannelWithUserAccount_0e4f59e(token, channelId, userAccount) {
        let irisClient = this._engine.irisClientManager.getIrisClient();
        return this.joinChannelWithUserAccount_4685af9(token, channelId, userAccount, irisClient.irisClientState);
    }
    joinChannelWithUserAccount_4685af9(token, channelId, userAccount, options) {
        let processJoinChannel = () => __awaiter(this, void 0, void 0, function* () {
            // AUDIT-v18: missing await. Senza await, returnResult() ritornava prima
            // che il join concludesse → chiamate successive (updateChannelMediaOptions,
            // publishTrack) trovavano agoraRTCClient undefined o non joined.
            try {
                yield this._engine.implHelper.joinChannel(token, channelId, userAccount, options);
            }
            catch (e) {
                AgoraConsole_1.AgoraConsole.error(`joinChannelWithUserAccount_4685af9 failed: ${e}`);
                return this._engine.returnResult(false);
            }
            return this._engine.returnResult();
        });
        return this._engine.execute(processJoinChannel);
    }
    // Impl per v0.9.2 (originariamente stub "not supported").
    // Variante user-account di joinChannelEx: client.join riceve la stringa userAccount
    // come ultimo parametro; Agora Web SDK assegna internamente un uid numerico
    // (leggibile da agoraRTCClient._joinInfo.uid). Popoliamo la UserInfo cache per
    // permettere getUserInfoByUid / getUserInfoByUserAccount successivi.
    joinChannelWithUserAccountEx_268b977(token, channelId, userAccount, options) {
        let processJoinChannel = () => __awaiter(this, void 0, void 0, function* () {
            var _a;
            let irisClient = new IrisClient_1.IrisClient(this._engine);
            // La connection definitiva viene assegnata dopo il join (localUid numerico
            // arriva da agoraRTCClient._joinInfo.uid).
            let con = {
                channelId: channelId,
                localUid: 0,
            };
            irisClient.connection = con;
            irisClient.createClient(options);
            irisClient.irisClientState.token = token;
            let agoraRTCClient = irisClient.agoraRTCClient;
            try {
                yield agoraRTCClient.join(this._engine.globalState.rtcEngineContext.appId, channelId, token ? token : null, userAccount);
            }
            catch (reason) {
                AgoraConsole_1.AgoraConsole.error(reason);
                this._engine.rtcEngineEventHandler.onError_d26c0fd(NATIVE_RTC.ERROR_CODE_TYPE.ERR_JOIN_CHANNEL_REJECTED, '');
                // AUDIT-v18: await release — senza await il cleanup è asincrono e può
                // lasciare un orphan IrisClient in irisClientList se il chiamante
                // rilancia subito un altro joinChannelWithUserAccountEx.
                try {
                    yield irisClient.release();
                }
                catch (_b) { }
                return this._engine.returnResult(false);
            }
            //@ts-ignore websdk private field: numeric uid assigned by Agora
            if (agoraRTCClient.isStringUID) {
                //@ts-ignore
                con.localUid = (_a = agoraRTCClient._joinInfo) === null || _a === void 0 ? void 0 : _a.uid;
                this._engine.irisClientManager.addUserInfo({
                    uid: con.localUid,
                    userAccount: userAccount,
                });
            }
            irisClient.connection = con;
            this._engine.rtcEngineEventHandler.onJoinChannelSuccess_263e4cd(con, 0);
            yield this._engine.irisClientManager.irisClientObserver.notifyLocal(IrisClientObserver_1.NotifyType.PUBLISH_TRACK, [
                ...this._engine.irisClientManager.localAudioTrackPackages,
                ...this._engine.irisClientManager.localVideoTrackPackages,
            ], [irisClient]);
            return this._engine.returnResult();
        });
        return this._engine.execute(processJoinChannel);
    }
    // Impl per v0.9.2 (originariamente stub "not supported").
    // Variante user-account di leaveChannelEx: il Dart SDK ci passa
    // (channelId, userAccount, options?). Risolviamo userAccount → numericUid
    // via UserInfo cache (popolata in joinChannelWithUserAccountEx_268b977),
    // costruiamo RtcConnection e riusiamo la logica di leaveChannelEx_b03ee9a.
    // Se non troviamo UserInfo (edge case post-release), facciamo fallback
    // sul matching per channelId in irisClientList.
    leaveChannelWithUserAccountEx_8bbe372(channelId, userAccount, options) {
        let processFunc = () => __awaiter(this, void 0, void 0, function* () {
            var _a;
            if (!options) {
                options = DefaultValue_1.defaultLeaveChannelOptions;
            }
            if (this._engine.irisClientManager.irisClientList.length === 0) {
                return this._engine.returnResult();
            }
            let userInfo = this._engine.irisClientManager.getUserInfoByUserAccount(userAccount);
            let irisClient;
            if (userInfo) {
                let connection = {
                    channelId: channelId,
                    localUid: userInfo.uid,
                };
                irisClient = this._engine.irisClientManager.getIrisClientByConnection(connection);
            }
            // Fallback: scorri i client e trova quello con channelId match
            // (il primario è posizione 0 — evita di toccare la connessione main).
            if (!irisClient) {
                for (let i = 1; i < this._engine.irisClientManager.irisClientList.length; i++) {
                    let c = this._engine.irisClientManager.irisClientList[i];
                    if (((_a = c === null || c === void 0 ? void 0 : c.connection) === null || _a === void 0 ? void 0 : _a.channelId) === channelId) {
                        irisClient = c;
                        break;
                    }
                }
            }
            if (!irisClient) {
                return this._engine.returnResult();
            }
            let agoraRTCClient = irisClient.agoraRTCClient;
            let connection = irisClient.connection;
            // Fix multi-client: l'originale passava tutti i track globali (main+secondary)
            // a notifyLocal(UNPUBLISH_TRACK), unpublishing anche la camera/mic del main
            // quando si voleva solo chiudere il secondary screen share. Passiamo solo
            // i track del client che stiamo lasciando (tipicamente zero sul secondary
            // perché il chiamante ha già rimosso lo screen pkg via JS).
            let toUnpublish = [...irisClient.audioTrackPackages];
            if (irisClient.videoTrackPackage) {
                toUnpublish.push(irisClient.videoTrackPackage);
            }
            yield this._engine.irisClientManager.irisClientObserver.notifyLocal(IrisClientObserver_1.NotifyType.UNPUBLISH_TRACK, toUnpublish);
            if (agoraRTCClient) {
                for (let trackPackage of irisClient.audioTrackPackages) {
                    if (trackPackage.track) {
                        let track = trackPackage.track;
                        if (options.stopMicrophoneRecording) {
                            yield this._engine.trackHelper.setMuted(track, true);
                        }
                    }
                }
                if (options.stopAllEffect) {
                    this._engine.getImplInstance('RtcEngine').stopAllEffects();
                }
                try {
                    yield this._engine.clientHelper.leave(agoraRTCClient);
                }
                catch (e) {
                    AgoraConsole_1.AgoraConsole.error(e);
                    this._engine.returnResult(false);
                    this._engine.rtcEngineEventHandler.onError_d26c0fd(NATIVE_RTC.ERROR_CODE_TYPE.ERR_LEAVE_CHANNEL_REJECTED, '');
                }
                this._engine.rtcEngineEventHandler.onLeaveChannel_c8e730d(connection, new NATIVE_RTC.RtcStats());
                if (userInfo && userInfo.uid != null) {
                    this._engine.irisClientManager.removeUserInfoByUid(userInfo.uid);
                }
                yield irisClient.release();
            }
            return this._engine.returnResult();
        });
        return this._engine.execute(processFunc);
    }
    leaveChannelWithUserAccountEx_ccad422(channelId, userAccount) {
        return this.leaveChannelWithUserAccountEx_8bbe372(channelId, userAccount, DefaultValue_1.defaultLeaveChannelOptions);
    }
    getUserInfoByUserAccount_c6a8f08(userAccount) {
        let user = this._engine.irisClientManager.getUserInfoByUserAccount(userAccount);
        return this._engine.returnResult(true, 0, JSON.stringify({
            result: 0,
            userInfo: user !== null && user !== void 0 ? user : { uid: null, userAccount: null },
        }));
    }
    getUserInfoByUid_6b7aee8(uid) {
        let user = this._engine.irisClientManager.getUserInfoByUid(uid);
        return this._engine.returnResult(true, 0, JSON.stringify({
            result: 0,
            userInfo: user !== null && user !== void 0 ? user : { uid: null, userAccount: null },
        }));
    }
    setLocalRenderMode_cfb201b(renderMode, mirrorMode) {
        let config = {
            fit: AgoraTranslate_1.AgoraTranslate.NATIVE_RTC_RENDER_MODE_TYPE2Fit(renderMode ? renderMode : NATIVE_RTC.RENDER_MODE_TYPE.RENDER_MODE_FIT),
            mirror: mirrorMode ===
                NATIVE_RTC.VIDEO_MIRROR_MODE_TYPE.VIDEO_MIRROR_MODE_AUTO ||
                mirrorMode ===
                    NATIVE_RTC.VIDEO_MIRROR_MODE_TYPE.VIDEO_MIRROR_MODE_ENABLED,
        };
        this._engine.irisClientManager.localVideoTrackPackages.map((videoTrackPackage) => {
            let track = videoTrackPackage.track;
            videoTrackPackage.videoPlayerConfig = config;
            if (track) {
                this._engine.trackHelper.play(track, videoTrackPackage.element, videoTrackPackage.videoPlayerConfig);
            }
        });
        return this._engine.returnResult();
    }
    setRemoteRenderMode_6771ce0(uid, renderMode, mirrorMode) {
        var _a;
        let config = {
            fit: AgoraTranslate_1.AgoraTranslate.NATIVE_RTC_RENDER_MODE_TYPE2Fit(renderMode ? renderMode : NATIVE_RTC.RENDER_MODE_TYPE.RENDER_MODE_FIT),
            mirror: mirrorMode ===
                NATIVE_RTC.VIDEO_MIRROR_MODE_TYPE.VIDEO_MIRROR_MODE_AUTO ||
                mirrorMode ===
                    NATIVE_RTC.VIDEO_MIRROR_MODE_TYPE.VIDEO_MIRROR_MODE_ENABLED,
        };
        let remoteUserPackage = this._engine.irisClientManager.remoteUserPackages.find((user) => {
            return user.uid === uid;
        });
        if (remoteUserPackage) {
            let irisClient = this._engine.irisClientManager.getIrisClientByConnection(remoteUserPackage.connection);
            if (irisClient) {
                // Fix user-account mode: match via _uintid, not string userAccount.
                let user = (_a = irisClient.agoraRTCClient) === null || _a === void 0 ? void 0 : _a.remoteUsers.find((item) => (0, AgoraTool_1.getUidFromRemoteUser)(item) === remoteUserPackage.uid);
                if (user && user.hasVideo) {
                    remoteUserPackage.videoPlayerConfig = config;
                    if (user.videoTrack) {
                        this._engine.trackHelper.play(user.videoTrack, remoteUserPackage.element, remoteUserPackage.videoPlayerConfig);
                    }
                }
            }
        }
        return this._engine.returnResult();
    }
    setLocalRenderMode_bedb5ae(renderMode) {
        let fit = AgoraTranslate_1.AgoraTranslate.NATIVE_RTC_RENDER_MODE_TYPE2Fit(renderMode ? renderMode : NATIVE_RTC.RENDER_MODE_TYPE.RENDER_MODE_FIT);
        this._engine.irisClientManager.localVideoTrackPackages.map((videoTrackPackage) => {
            let track = videoTrackPackage.track;
            videoTrackPackage.videoPlayerConfig.fit = fit;
            if (track) {
                this._engine.trackHelper.play(track, videoTrackPackage.element, videoTrackPackage.videoPlayerConfig);
            }
        });
        return this._engine.returnResult();
    }
    setLocalVideoMirrorMode_b8a6c69(mirrorMode) {
        let mirror = mirrorMode === NATIVE_RTC.VIDEO_MIRROR_MODE_TYPE.VIDEO_MIRROR_MODE_AUTO ||
            mirrorMode ===
                NATIVE_RTC.VIDEO_MIRROR_MODE_TYPE.VIDEO_MIRROR_MODE_ENABLED;
        this._engine.irisClientManager.localVideoTrackPackages.map((videoTrackPackage) => {
            let track = videoTrackPackage.track;
            videoTrackPackage.videoPlayerConfig.mirror = mirror;
            if (track) {
                this._engine.trackHelper.play(track, videoTrackPackage.element, videoTrackPackage.videoPlayerConfig);
            }
        });
        return this._engine.returnResult();
    }
    setPlaybackAudioFrameParameters_bd46d1d(sampleRate, channel, mode, samplesPerCall) {
        //websdk do not have sampleRate, channel, mode
        let fun = () => __awaiter(this, void 0, void 0, function* () {
            try {
                this._engine.globalState.isAudioFrameParametersSet = samplesPerCall > 0;
                if (!this._engine.globalState.isAudioFrameParametersSet) {
                    this._engine.irisClientManager.irisClientList.map((irisClient) => {
                        var _a;
                        (_a = irisClient.agoraRTCClient) === null || _a === void 0 ? void 0 : _a.remoteUsers.map((remoteUser) => {
                            var _a;
                            (_a = remoteUser.audioTrack) === null || _a === void 0 ? void 0 : _a.setAudioFrameCallback(null, samplesPerCall);
                        });
                    });
                }
                else {
                    this._engine.globalState.audioFrameParameters = {
                        sampleRate,
                        channel,
                        mode,
                        samplesPerCall,
                    };
                }
            }
            catch (e) {
                AgoraConsole_1.AgoraConsole.log(e);
                return this._engine.returnResult(false);
            }
            return this._engine.returnResult();
        });
        return this._engine.execute(fun);
    }
    setRemoteVideoStreamType_9e6406e(uid, streamType) {
        let fun = () => __awaiter(this, void 0, void 0, function* () {
            try {
                for (let i = 0; i < this._engine.irisClientManager.irisClientList.length; i++) {
                    let irisClient = this._engine.irisClientManager.irisClientList[i];
                    let agoraRTCClient = irisClient.agoraRTCClient;
                    if (agoraRTCClient &&
                        agoraRTCClient.remoteUsers.filter((user) => {
                            // Fix user-account mode: user.uid may be string userAccount.
                            return (0, AgoraTool_1.getUidFromRemoteUser)(user) === uid;
                        }).length > 0) {
                        yield agoraRTCClient.setRemoteVideoStreamType(uid, AgoraTranslate_1.AgoraTranslate.NATIVE_RTC_VIDEO_STREAM_TYPE2Number(streamType));
                    }
                }
            }
            catch (e) {
                AgoraConsole_1.AgoraConsole.log(e);
                return this._engine.returnResult(false);
            }
            return this._engine.returnResult();
        });
        return this._engine.execute(fun);
    }
    sendCustomReportMessage_56d6589(id, category, event, label, value) {
        let fun = () => __awaiter(this, void 0, void 0, function* () {
            try {
                let agoraRTCClient = this._engine.irisClientManager.getIrisClient()
                    .agoraRTCClient;
                if (agoraRTCClient) {
                    yield agoraRTCClient.sendCustomReportMessage({
                        reportId: id,
                        category: category,
                        event: event,
                        label: label,
                        value: value,
                    });
                }
            }
            catch (e) {
                AgoraConsole_1.AgoraConsole.log(e);
                return this._engine.returnResult(false);
            }
            return this._engine.returnResult();
        });
        return this._engine.execute(fun);
    }
    // GEN-153: virtual background + blur su camera primary.
    // Flow:
    //   1) cache config in globalState (enabled + source)
    //   2) se camera track esiste → apply immediato (pipe + setOptions + enable/disable)
    //   3) se camera track non esiste ancora → config applicata in startPreview
    //      dopo createVideoCameraTrack (chiamata a _applyVirtualBackgroundToCameraTrack)
    //
    // NOTE: processor è lazy. Prima init() blocca su fetch wasm (~500ms-1s).
    // Successive setOptions sono sync. Un processor viene riutilizzato attraverso
    // diverse impostazioni (blur/image/disabled) cambiando solo options.
    enableVirtualBackground_6dd8ee4(enabled, backgroundSource, segproperty, type) {
        let processFunc = () => __awaiter(this, void 0, void 0, function* () {
            this._engine.globalState.virtualBackgroundEnabled = enabled;
            this._engine.globalState.virtualBackgroundSource = backgroundSource;
            const track = this._findLocalCameraTrack();
            if (!track) {
                AgoraConsole_1.AgoraConsole.debug('[VirtualBg] camera track non ancora creato, config cached; verrà applicata allo start');
                return this._engine.returnResult();
            }
            try {
                yield this._applyVirtualBackgroundToCameraTrack(track);
            }
            catch (e) {
                AgoraConsole_1.AgoraConsole.error(`[VirtualBg] apply error: ${e}`);
                return this._engine.returnResult(false);
            }
            return this._engine.returnResult();
        });
        return this._engine.execute(processFunc);
    }
    // Helper: trova il primary camera track locale (ICameraVideoTrack).
    // Ritorna undefined se track non ancora creato.
    _findLocalCameraTrack() {
        const packages = this._engine.irisClientManager.localVideoTrackPackages.filter((p) => this._engine.implHelper.isVideoCamera(p.type));
        for (const p of packages) {
            if (p.track)
                return p.track;
        }
        return undefined;
    }
    // Helper chiamabile sia da enableVirtualBackground sia dal hook
    // post-createVideoCameraTrack in startPreview (config cached applicata
    // quando track diventa disponibile).
    //
    // Logic:
    //   - lazy-create processor dall'extension (richiede wasm init 1x)
    //   - setOptions in base a backgroundSource (type mapping: blur/img/color)
    //   - se non già piped: track.pipe(processor).pipe(track.processorDestination)
    //   - enable/disable processor in base a flag enabled
    _applyVirtualBackgroundToCameraTrack(track) {
        return __awaiter(this, void 0, void 0, function* () {
            const gs = this._engine.globalState;
            const ext = gs.virtualBackgroundExtension;
            if (!ext) {
                AgoraConsole_1.AgoraConsole.warn('[VirtualBg] extension non disponibile — skip');
                return;
            }
            // Lazy-init processor + wasm. Il primo init può impiegare qualche centinaio
            // di ms. Idempotente: chiamare init() di nuovo è no-op dopo il primo.
            if (!gs.virtualBackgroundProcessor) {
                const processor = ext.createProcessor();
                yield processor.init();
                gs.virtualBackgroundProcessor = processor;
                // Pipe UNA VOLTA: track.pipe ritorna il processor, pipe(processorDestination)
                // chiude la catena. Resto degli update vanno via setOptions/enable/disable.
                track
                    .pipe(processor)
                    .pipe(track.processorDestination);
                gs.virtualBackgroundPipedTrack = track;
            }
            else if (gs.virtualBackgroundPipedTrack !== track) {
                // AUDIT-v18: ripipe solo se track è effettivamente cambiato (camera
                // ricreata). Se track è lo stesso già piped → no-op. Previene canvas
                // pipeline rebuild ridondante su ogni toggle blur.
                try {
                    track
                        .pipe(gs.virtualBackgroundProcessor)
                        .pipe(track.processorDestination);
                    gs.virtualBackgroundPipedTrack = track;
                }
                catch (e) {
                    AgoraConsole_1.AgoraConsole.warn(`[VirtualBg] re-pipe warning: ${e}`);
                }
            }
            const processor = gs.virtualBackgroundProcessor;
            const src = gs.virtualBackgroundSource;
            if (!gs.virtualBackgroundEnabled || !src) {
                yield processor.disable();
                AgoraConsole_1.AgoraConsole.debug('[VirtualBg] disabled');
                return;
            }
            // Translate NATIVE_RTC.VirtualBackgroundSource → extension options.
            // Flutter side sends: background_source_type (enum), color (int ARGB),
            // source (path), blur_degree (1-3).
            const typeEnum = src.background_source_type;
            const blurDegree = src.blur_degree;
            const sourcePath = src.source;
            const colorInt = src.color;
            try {
                if (typeEnum === NATIVE_RTC.BACKGROUND_SOURCE_TYPE.BACKGROUND_BLUR) {
                    processor.setOptions({
                        type: 'blur',
                        blurDegree: blurDegree !== null && blurDegree !== void 0 ? blurDegree : 2,
                    });
                }
                else if (typeEnum === NATIVE_RTC.BACKGROUND_SOURCE_TYPE.BACKGROUND_IMG) {
                    // source è URL/path relativo a web/. Carica in HTMLImageElement per
                    // l'extension (richiede HTMLImageElement | HTMLVideoElement).
                    const img = yield this._loadBackgroundImage(sourcePath);
                    processor.setOptions({
                        type: 'img',
                        source: img,
                    });
                }
                else if (typeEnum === NATIVE_RTC.BACKGROUND_SOURCE_TYPE.BACKGROUND_COLOR) {
                    // colorInt è 0xRRGGBB; convert in CSS color.
                    const hex = (colorInt !== null && colorInt !== void 0 ? colorInt : 0xffffff).toString(16).padStart(6, '0');
                    processor.setOptions({
                        type: 'color',
                        color: `#${hex}`,
                    });
                }
                else {
                    // BACKGROUND_NONE o VIDEO (non supportato web): disable.
                    yield processor.disable();
                    AgoraConsole_1.AgoraConsole.debug('[VirtualBg] type none/video → disabled');
                    return;
                }
                yield processor.enable();
                AgoraConsole_1.AgoraConsole.debug(`[VirtualBg] enabled type=${typeEnum}`);
            }
            catch (e) {
                AgoraConsole_1.AgoraConsole.error(`[VirtualBg] setOptions/enable error: ${e}`);
                throw e;
            }
        });
    }
    _loadBackgroundImage(src) {
        return new Promise((resolve, reject) => {
            const img = new Image();
            img.crossOrigin = 'anonymous';
            img.onload = () => resolve(img);
            img.onerror = (e) => reject(e);
            img.src = src;
        });
    }
}
exports.IRtcEngineImpl = IRtcEngineImpl;
